import React from 'react';
import { Button } from 'new/elements/Button';
import { ServiceKeysTable } from 'new/components/settings/Authentication/ServiceKeys/ServiceKeysTable/ServiceKeysTable';
import { ServiceKeyOverview } from './ServiceKeyOverview';
import { fetchAllServiceKeys } from 'js/actions';
import NoContentTextView from 'js/components/elements/NoContentTextView';
import { useServiceKeys } from 'new/components/settings/Authentication/ServiceKeys/useServiceKey';

import styles from './styles.module.scss';
import { useModals } from 'new/hooks/useModals';
import { CreateServiceKeyModal } from 'new/components/settings/Authentication/ServiceKeys/CreateServiceKeyModal';
import { ReactComponent as PlusIcon } from 'new/components/icons/fi-rr-plus.svg';

const detailViewTabs = [
  {
    tabName: '',
    tabElement: ServiceKeyOverview,
  },
];

export const HeaderElement = () => {
  const { openModal } = useModals();
  const { create } = useServiceKeys();

  const openCreateServiceKeyModal = () => {
    openModal(CreateServiceKeyModal.modalConfig.name, {
      createServiceKey: create,
    });
  };

  return (
    <div className={styles.serviceKeysDescriptionContainer}>
      <p className={styles.serviceKeysDescription}>
        Securely authenticate and authorize API access with unique API keys. Safeguard sensitive
        data and ensure authorized usage within your application.
      </p>

      <Button
        variant="contained"
        onClick={openCreateServiceKeyModal}
        className={styles.addKeyButton}
        startIcon={<PlusIcon />}
      >
        Create Service Key
      </Button>
    </div>
  );
};

export function ServiceKeys() {
  const { data, error, isLoading } = useServiceKeys();

  let noContentView = null;
  if ((data.length === 0 && !isLoading) || error) {
    const message = error
      ? 'Sorry, something went wrong.'
      : 'Looks empty here. You have no API keys, try creating one.';
    // @ts-ignore
    noContentView = <NoContentTextView title={message} />;
  }

  const Header = React.useCallback(HeaderElement, []);

  return (
    <div className={styles.container}>
      <Header />
      <ServiceKeysTable
        isLoading={isLoading}
        detailViewTabs={detailViewTabs}
        loadData={fetchAllServiceKeys}
        noContentView={noContentView}
      />
    </div>
  );
}
